const FOOTER_COLS = [
  {
    title: "栏目",
    links: [
      { label: "独家调查", href: "#reports" },
      { label: "民生观察", href: "#reports" },
      { label: "财经追踪", href: "#reports" },
      { label: "一线声音", href: "#reports" },
    ],
  },
  {
    title: "参与爆料",
    links: [
      { label: "匿名投稿", href: "#channel-anon" },
      { label: "私信爆料", href: "#channel-dm" },
      { label: "在线线索征集", href: "#channel-tip" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "报道原则", href: "#principles" },
      { label: "保护指引", href: "#protect" },
      { label: "常见问题", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl font-bold text-foreground-900">
                今日<span className="text-primary-600">爆料</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              职场黑幕、社会不公——只要你敢说，我们就敢深挖。以匿名、保护与核实为底线的公共监督平台。
            </p>
            <p className="mt-4 text-sm text-foreground-500">
              合作 / 线索：<span className="text-foreground-700">tougao@jinribaoliao.example</span>
            </p>
          </div>

          {FOOTER_COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-900">{col.title}</h4>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 今日爆料 · 内容仅作信息参考，转载须注明出处
          </p>
          <div className="flex items-center gap-4 text-foreground-500">
            <a href="#" aria-label="微博" className="transition-colors hover:text-primary-600">
              <i className="ri-weibo-fill text-lg" aria-hidden="true"></i>
            </a>
            <a href="#" aria-label="公众号" className="transition-colors hover:text-primary-600">
              <i className="ri-wechat-fill text-lg" aria-hidden="true"></i>
            </a>
            <a href="#" aria-label="知乎" className="transition-colors hover:text-primary-600">
              <i className="ri-zhihu-line text-lg" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}